import Immutable from 'immutable'

/**
 * Note: this type of credit card is used as a data
 * representation of actual unencrypted card details
 * for data binding.
 *
 * It should not be serialized or sent anywhere! Make
 * sure you run the eCrypt functions over the CVN, and
 * card number!
 */

export const CreditCardRecord = Immutable.Record({
  cvn: '',
  expiry_month: '',
  expiry_year: '',
  name: '',
  number: '',
}, 'CreditCard')

export default function createCreditCard(data) {
  return new CreditCardRecord(data)
}

export function isEmpty(card) {
  return Immutable.is(card, createCreditCard())
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/CreditCard.js